import { findDataset } from '~/Api/Product/Dataset';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import { Action, ActionType } from './Action';
import { selectDatasetByProductId, State } from './reducer';

export function loadDataset(productId: string): ThunkAction<Promise<void>, Action> {
	return async (dispatch, getState) => {
		const datasetState = selectDatasetByProductId(getState().productDataset, productId);
		await (datasetState?.request ?? dispatch(fetchDataset(productId)));
	};
}

export function fetchDataset(productId: string): ThunkAction<Promise<void>, Action> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findDataset, productId));
		dispatch({ type: ActionType.request, request, productId });
		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionType.receive,
				request,
				productId,
				dataset: response?.dataset ?? null,
			});
			if (error !== null) {
				dispatch(handleError(error));
			}
		});
	};
}

export function pruneDatasets(): Action {
	return { type: ActionType.pruneAll };
}
